import { GetStatisticsResponseDto } from '../../../mobile-bff/vehicle/dto';

export type CrmVehicleGetStatisticsResponseDto = GetStatisticsResponseDto;

export * from '../../../mobile-bff/vehicle/dto/get-statistics.response.dto';
